import { render, staticRenderFns } from "./MerchandiserSelect.vue?vue&type=template&id=6d81cf8c&"
import script from "./MerchandiserSelect.vue?vue&type=script&lang=ts&"
export * from "./MerchandiserSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports